export function checkoutPrimaryButtonClassName(isLoading: boolean): string {
  const stateClassName = isLoading
    ? "text-transparent hover:text-transparent disabled:bg-utility-gray-800 disabled:text-transparent [&_svg]:text-text-white"
    : "text-text-white hover:text-text-white";

  return `w-full bg-utility-gray-800 hover:bg-utility-gray-900 ${stateClassName}`;
}

export const stripeFieldClassName = [
  "rounded-md border border-border-primary bg-bg-primary px-[14px] py-[12px] shadow-xs",
  "[&.StripeElement--focus]:border-border-brand [&.StripeElement--focus]:ring-4 [&.StripeElement--focus]:ring-border-brand/25",
  "[&.StripeElement--invalid]:border-border-error data-[invalid]:border-border-error",
].join(" ");
